import { frontendURL } from '../../../helper/URLHelper';
import KanbanIndex from './pages/KanbanIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_index',
    component: KanbanIndex,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
